<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 支付金额校验信息提示卡片
 * @Date: 2021-09-10 14:21:27
 * @LastEditTime: 2022-02-18 11:13:28
-->
<template>
  <div v-if="rechargeForm" class="pay-info margin-auto mt-5 text-sm ml-10">
    <div v-if="isShowMinTip" class="">Minimum amount is ${{ moneyInfo?.minAmount }}</div>
    <div v-else-if="isShowMaxTip">Maxmum amount is ${{ moneyInfo?.maxAmount }}</div>
    <div
      v-show="isShowReceivedMoney"
      class="text-sm discounts"
    >
      Totally received: 
      <b>$ {{ totalMoney }}</b> <span v-show="rechargeForm.activeRate">({{ rechargeForm.activeRate }}% bonus)</span>
    </div>

    <div
      v-if="selectPayInfo.inputHint"
      class="text-sm"
      :class="rechargeForm.money >= moneyInfo?.minAmount && rechargeForm.realMoney
        ? 'recharge-form-tips recharge-form-tips3'
        : 'recharge-form-tips'"
    >
      {{ selectPayInfo.inputHint }}
    </div>

  </div>
</template>

<script>
import { computed} from 'vue'
export default {
  props:{
    rechargeForm:{
      type:Object,
      default:()=>null
    },
    selectPayInfo:{
      type:Object,
      default:()=>null
    },
    moneyInfo:{
      type:Object,
      default:()=>null
    }
  },
  setup(props){
    const showTipByType = computed(() => {
      return props.selectPayInfo.type!=='BANK'
    })
    //低于最小金额提示
    const isShowMinTip=computed(()=>{
      return ((props.rechargeForm.money && props.rechargeForm.money<20)||(!props.rechargeForm.money&&props.moneyInfo?.isClickBtn))&&showTipByType.value
    })
    //大于最大金额提示
    const isShowMaxTip=computed(()=>{
      return props.moneyInfo?.maxAmount&&props.rechargeForm.money>props.moneyInfo?.maxAmount&&showTipByType.value
    })
    //金额汇总提示
    const isShowReceivedMoney=computed(()=>{
      return props.rechargeForm.money&&(props.selectPayInfo.type!=='PACY_PAY'&&props.rechargeForm.money >= props.moneyInfo?.minAmount )&&(props.moneyInfo?.maxAmount?props.rechargeForm.money<=props.moneyInfo?.maxAmount:true)&&showTipByType.value
    })

    const totalMoney=computed(()=>{
      return props.rechargeForm.totalMoney ||props.rechargeForm.realMoney||props.rechargeForm.money|| 0
    })
    return {
      isShowMinTip,isShowMaxTip,isShowReceivedMoney,totalMoney
    }
  }
}

</script>
<style lang="scss" scoped>
  .discounts {
    color: $fontColor;

    b {
      color: #00c800;
    }

    span {
      color: #ed2027;
    }
  }

  .recharge-form-tips {
    color: #f99945;
  }
</style>